import type {
  ProcurementContainerType,
  ProcurementStatusTemplate,
  ProcurementTerm,
  ProcurementUnitType,
} from '@/types/api'
import { createCrudService } from '../crud'

export type ProcurementNamedInput = Pick<
  ProcurementTerm,
  'code' | 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status'
>

export type ProcurementContainerTypeInput = ProcurementNamedInput & {
  capacity_kg: string
  unit_type: ProcurementUnitType
}

export type ProcurementStatusTemplateInput = ProcurementNamedInput & { order_number: number }

export const procurementTermsService = createCrudService<
  ProcurementTerm,
  ProcurementNamedInput,
  Partial<ProcurementNamedInput>
>('procurement/terms', { updateMethod: 'patch' })

export const procurementContainerTypesService = createCrudService<
  ProcurementContainerType,
  ProcurementContainerTypeInput,
  Partial<ProcurementContainerTypeInput>
>('procurement/container-types', { updateMethod: 'patch' })

export const procurementStatusTemplatesService = createCrudService<
  ProcurementStatusTemplate,
  ProcurementStatusTemplateInput,
  Partial<ProcurementStatusTemplateInput>
>('procurement/status-templates', { updateMethod: 'patch' })
